import React from "react"

import { PrimaryText } from "./primaryText.element"

import infoCircleIcon from "@front-shared/assets/images/icons/info-circle.svg"

export const InfoNoticeElement: React.FunctionComponent<
    IInfoNoticeElementProps
> = props => {
    return (
        <div
            className={`
                flex items-start gap-[8px] rounded-[8px]
                border border-solid border-brand-vibrantPurple
                bg-brand-lilacLight px-[16px] py-[12px]
                ${props.className ?? ""}
            `}
        >
            <img
                className="h-[14px] w-[14px] shrink-0 relative top-[3px]"
                src={infoCircleIcon}
                alt=""
            />

            <PrimaryText typography="textSmall">{props.children}</PrimaryText>
        </div>
    )
}

interface IInfoNoticeElementProps {
    children?: React.ReactNode
    className?: string
}
